import React from "react";
import { STAGE_TOP_PADDING } from "@/constants/UIConstants";

import styles from "./Guides.module.css";

/**
 * @typedef {import("@/utils/Snapping/FindSnapMatches").SnappingGuides} SnappingGuides
 */

/**
 *
 * @param {Object} props
 * @param {SnappingGuides} props.snapGuides
 * @returns
 */
const SnapGuides = ({ snapGuides }) => {
  return (
    <>
      {snapGuides?.x?.map((guideLine) => (
        <line
          className={styles.snapGuide}
          key={`guide-${guideLine.x1}-${guideLine.y1}`}
          x1={guideLine.x1}
          y1={guideLine.y1 + STAGE_TOP_PADDING}
          x2={guideLine.x2}
          y2={guideLine.y2 + STAGE_TOP_PADDING}
          strokeDasharray={guideLine.stroke === "solid" ? "" : "3 3"}
        />
      ))}
      {snapGuides?.y?.map((guideLine) => (
        <line
          className={styles.snapGuide}
          key={`guide-${guideLine.x1}-${guideLine.y1}`}
          x1={guideLine.x1}
          y1={guideLine.y1 + STAGE_TOP_PADDING}
          x2={guideLine.x2}
          y2={guideLine.y2 + STAGE_TOP_PADDING}
          strokeDasharray={guideLine.stroke === "solid" ? "" : "3 3"}
        />
      ))}
    </>
  );
};

export default SnapGuides;
